export default __webpack_public_path__ + "static/media/c38ad7bb9d51153d8aa676112a78bff4.svg";